import { AccountService } from './../../core/services/account.service';
import { DeployPurchase, InfoPurchase, RedeemSuscriptionBody } from './../../core/interfaces/purchase.model';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { Component, OnInit, AfterViewInit, OnDestroy } from '@angular/core';
import { ParametersService } from 'src/app/core/services/parameters.service';
import Swal from 'sweetalert2';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';
import { Account, Suscription } from 'src/app/core/interfaces/user.model';
import { AuthService } from 'src/app/core/auth/auth.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TransactionsService } from 'src/app/core/services/transactions.service';

@Component({
  selector: 'app-suscription',
  templateUrl: './suscription.component.html',
  styleUrls: ['./suscription.component.css'],
})
export class SuscriptionComponent implements OnInit, AfterViewInit, OnDestroy {
  loading = false;

  suscription: Suscription;
  condiciones = false;
  couponForm: FormGroup;

  modalPayment: any;
  modalLogin: any;
  modalRegister: any;
  modalConditions: any;

  PARAMS: ParameterModel;

  subPriceRegular: string;
  subPriceSocios: string;
  subPriceAnualRegular: string;
  subPriceAnualSocios: string;

  objetoPurchase: DeployPurchase = {
    type: 'suscription',
    subscriptionPlanId: 0,
  };
  infoCompra: InfoPurchase;

  account: Account;
  isCinematecaMember = true;

  plansAll = [
    {
      id: 9,
      idAnual: 11,
      name: 'Suscripción Regular',
      nameAnual: 'Suscripción Regular Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: false,
    },
    {
      id: 10,
      idAnual: 12,
      name: 'Suscripción Regular para Socios',
      nameAnual: 'Suscripción Regular para Socios Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: true,
    },
    {
      id: 13,
      idAnual: 14,
      name: 'Suscripción Felix Oliver',
      nameAnual: 'Suscripción Felix Oliver Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: false,
    },
    {
      id: 18,
      idAnual: 19,
      name: 'Suscripción Felix Oliver Para Socios',
      nameAnual: 'Suscripción Felix Oliver Para Socios Anual',
      description: '',
      price: 0,
      anualprice: 0,
      subtitle: 'Siendo parte de +Cinemateca podés disfrutar de:',
      texto1: 'Un catálogo de más de 400 películas',
      texto2: 'Contenidos exclusivos producidos por Cinemateca',
      texto3: 'Muestras de festivales uruguayos',
      texto4: 'Materiales de nuestro archivo fílmico digitalizados',
      footer: 'Y lo más importante... apoyás a Cinemateca.',
      isForMember: true,
    },
  ];
  plans = [];

  constructor(
    private accountService: AccountService,
    private paramService: ParametersService,
    private authService: AuthService,
    private router: Router,
    private location: Location,
    private ParameterService: ParametersService,
    private transacionService: TransactionsService,
  ) {
    this.couponForm = new FormGroup({
      codigoCupon: new FormControl('', [Validators.required]),
    });
  }

  onSubmit() {
    let bodyPurchase: RedeemSuscriptionBody;
    bodyPurchase = {
      couponCode: this.couponForm.get('codigoCupon').value,
    };
    this.transacionService.redeemSuscriptionCoupon(bodyPurchase).subscribe(
      async (resp) => {
        if (resp.couponOK) {
          // Validamos la suscription y actualizamos el boton del header
          let account: any = await this.accountService.getAccount();

          if (account.suscription) {
            Swal.fire({
              icon: 'success',
              title: 'BIEN!',
              text:
                'Ahora estás suscripto a +CINEMATECA en el plan ' +
                resp.plan +
                ' hasta el ' +
                resp.expiration +
                '.\n Disfrute nuestro contenido!',
              confirmButtonText: 'ACEPTAR',
              customClass: { popup: 'sub_suscrito_success' },
              didClose: () => {
                this.router.navigateByUrl('/home');
              },
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'UPS!',
              text: 'Ha ocurrido un error en la suscripción. Vuelva a intentarlo en unos minutos.',
              confirmButtonText: 'ACEPTAR',
              didClose: () => { },
            });
          }
        } else {
          Swal.fire({
            icon: 'error',
            title: 'Cupon No Válido!',
            text: 'El cupon ingresado no es válido o ya fue usado.',
            confirmButtonText: 'ACEPTAR',
            didClose: () => { },
          });
        }
      },
      (error) => {
        //this.cargandoPago = false;

        Swal.fire({
          icon: 'error',
          title: 'Hubo un error',
          text: 'Se produjo un error. Intente nuevamente.',
        });
      },
    );
  }

  async ngOnInit() {
    this.loading = true;

    await this.cargarPrice();

    await this.paramService.getAllParameters().then(
      (params) => {
        this.loading = false;
        this.PARAMS = params;
      },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
    );

    this.suscription = null;

    await this.accountService.getAccount().then(
      async (resp: Account) => {
        if (resp) {
          this.account = resp;

          this.suscription = resp.suscription;

          this.plans = this.plansAll.filter((p) => p.isForMember == this.account.isCinematecaMember);

          this.loading = false;
        }
      },
      (error) => {

        if (error.status == 401) this.router.navigateByUrl('/home');
      },
    );
  }

  ngAfterViewInit(): void {
    this.modalLogin = $('#modalLogin');
    this.modalRegister = $('#modalRegister');
    this.modalPayment = $('#modalPayment');
    this.modalConditions = $('#modalConditions');
  }

  ngOnDestroy(): void {
    this.modalPayment.modal('hide');
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');
    this.modalConditions.modal('hide');
  }

  async confirmSuscriptionMensual(plan: any) {

    if (this.authService.estaAutenticado()) {
      if ((!this.account.suscription) || (this.account.suscription.status != 1)) {
        this.suscription = null;

        this.infoCompra = {
          type: 'subscription',
          title: plan.name,
          price: plan.price,
        };

        this.objetoPurchase.subscriptionPlanId = plan.id;//mensual para socio

        if (this.condiciones) this.abrirModal(this.modalPayment);
        else this.abrirModal(this.modalConditions);
      } else {
        Swal.fire({
          icon: 'info',
          title: 'Ya está suscripto',
          text: 'Usted ya se encuentra suscripto en +CINEMATECA.',
          confirmButtonText: 'IR AL CATÁLOGO',
          customClass: { popup: 'sub_suscrito_mensual' },
          didClose: () => {
            this.router.navigateByUrl('/home');
          },
        });
      }
    } else {
      this.abrirModal(this.modalLogin);
    }
  }

  async confirmSuscriptionAnual(plan: any) {
    if (this.authService.estaAutenticado()) {
      if ((!this.account.suscription) || (this.account.suscription.status != 1)) {
        this.suscription = null;

        this.infoCompra = {
          type: 'subscription',
          title: plan.nameAnual,
          price: plan.anualprice,
        };

        this.objetoPurchase.subscriptionPlanId = plan.idAnual;//mensual para socio


        if (this.condiciones) this.abrirModal(this.modalPayment);
        else this.abrirModal(this.modalConditions);
      } else {
        Swal.fire({
          icon: 'info',
          title: 'Ya está suscripto',
          text: 'Usted ya se encuentra suscripto en +CINEMATECA.',
          confirmButtonText: 'IR AL CATÁLOGO',
          customClass: { popup: 'sub_suscrito_anual' },
          didClose: () => {
            this.router.navigateByUrl('/home');
          },
        });
      }
    } else {
      this.abrirModal(this.modalLogin);
    }
  }

  back() {
    this.location.back();
  }

  //#region METODO Auth

  onLogin(respuesta) {
    if (respuesta) this.modalLogin.modal('hide');
  }

  onRegister(respuesta) {
    if (respuesta) this.modalRegister.modal('hide');
  }

  //#endregion

  /**
   * Abre modal declarado, se pasa por parámetro el identificador del DOM o el objeto modal
   * @param modal String || Object
   */
  abrirModal(modal: any) {
    this.modalPayment.modal('hide');
    this.modalLogin.modal('hide');
    this.modalRegister.modal('hide');
    this.modalConditions.modal('hide');

    if (modal) {
      if (typeof modal === 'string') this[modal].modal('show');
      if (typeof modal === 'object') modal.modal('show');
    }
  }

  onCondiciones(estado) {
    this.condiciones = estado;
    if (estado) this.abrirModal(this.modalPayment);
  }

  async cargarPrice() {
    await this.ParameterService.getAllSubPrices().then((res) => {
      if (res) {
        this.plansAll[0].price = parseInt(res[0].value)       //Regular Mensual
        this.plansAll[0].anualprice = parseInt(res[2].value)  //Regular Anual
        this.plansAll[1].price = parseInt(res[1].value)       //Regular Mensual Socios
        this.plansAll[1].anualprice = parseInt(res[3].value)  //Regular Anual Socios
        this.plansAll[2].price = parseInt(res[4].value)       //Felix Oliver Mensual
        this.plansAll[2].anualprice = parseInt(res[6].value)  //Felix Oliver Anual
        this.plansAll[3].price = parseInt(res[5].value)       //Felix Oliver Mensual Socios
        this.plansAll[3].anualprice = parseInt(res[7].value)  //Felix Oliver Anual Socios
      }
    })

  }
}
